import { gql } from '@/__generated__';

const GET_ACCESS_ORGANIZATION_FILTER = gql(`#graphql
  query GetAccessOrganizationFilter {
    authorization {
      authorizationGeneral {
        setOrganizacionAccess
      }
    }
  }
`);

export default GET_ACCESS_ORGANIZATION_FILTER;
